import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { handleCheckoutClick, CHECKOUT_URL } from '../lib/pixel';
export function Hero() {
  return <section className="bg-[#2D5A34] py-16 lg:py-24" data-id="element-90">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-91">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-92">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-93">
            <div className="inline-flex items-center gap-2 bg-[#C2856A] text-white px-4 py-2 rounded-full text-xs font-semibold mb-6" data-id="element-94">
              🌿 PROTOCOLO HORMONAL DIGITAL · ACCESO INMEDIATO
            </div>

            <h1 className="text-4xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-95">
              ¿Por qué no bajas de peso después de los 40, aunque hagas todo
              bien?
            </h1>

            <p className="text-xl lg:text-2xl text-white italic font-light mb-8" data-id="element-96">
              No es tu fuerza de voluntad. Es tu química hormonal. Y tiene
              solución en 21 días.
            </p>

            <ul className="mb-10" data-id="element-97">
              {['Sin contar calorías ni pasar hambre', 'Sin cardio agotador que eleva el cortisol', 'Plan día a día con menú y horarios exactos'].map((item, i) => <li key={i} className="flex items-start gap-3 mb-2" style={{
              lineHeight: 1.7
            }} data-id="element-98">
                  <CheckIcon className="w-5 h-5 flex-shrink-0 mt-1" strokeWidth={3} style={{
                color: '#A8D5AC'
              }} data-id="element-99" />
                  <span className="text-[15px] lg:text-[16px]" style={{
                color: '#DDEEDD'
              }} data-id="element-100">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6" data-id="element-101">
              <div className="flex items-baseline gap-3 mb-2" data-id="element-102">
                <span className="text-white/60 line-through text-lg" data-id="element-103">
                  $27.00
                </span>
                <span className="text-[#C9A84C] text-5xl font-bold" data-id="element-104">$8.49</span>
                <span className="text-white text-lg" data-id="element-105">USD</span>
              </div>
              <p className="text-[#C2856A] text-sm font-semibold" data-id="element-106">
                Oferta de lanzamiento · Precio sube pronto
              </p>
            </div>

            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="block text-center w-full lg:w-auto lg:inline-block bg-[#C9A84C] text-black px-10 py-5 rounded-full text-lg font-bold uppercase hover:brightness-110 transition-all shadow-lg mb-4" data-id="element-107">
              SÍ, QUIERO MI PROTOCOLO AHORA →
            </a>

            <p className="text-white/80 text-sm text-center lg:text-left" data-id="element-108">
              🔒 Pago 100% seguro · Descarga inmediata · Acceso en cualquier
              dispositivo
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative" data-id="element-109">
            <div className="relative" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/aFAuZswYJrt2D2RCJ8wJWV/MOCKUP-1.png" alt="Mujer latina sosteniendo tablet con eBook Código Hormonal 40+" className="w-full h-auto rounded-2xl" data-id="element-111" />
              <div className="absolute -top-4 -right-4 bg-[#C9A84C] text-black px-4 py-2 rounded-full text-sm font-bold shadow-lg" data-id="element-112">
                ⭐ +1,200 mujeres lo completaron
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}